import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MessagingActions } from "../../actions/messaging.actions";
import { MessageState } from "../../models/messaging/message-state";

const initialState: MessageState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MessagingActions.message.get, (state) => _.merge(_.cloneDeep(state), { loading: true })),
	on(MessagingActions.message.getSuccess, (state, action) => mergeMessages(state, action)),
	on(MessagingActions.message.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), { error: action.error, loading: false })
	),
	on(MessagingActions.conversation.read, (state, action) =>
		updateMessageReadState(state, action)
	),
	on(MessagingActions.conversation.readSuccess, (state, action) =>
		updateMessageReadState(state, action)
	),
	on(MessagingActions.conversation.readFail, (state, action) =>
		updateMessageReadState(state, action)
	),
	on(MessagingActions.message.wsReceived, (state, action) => insertMessage(state, action.message))
);

const archiveReducer = createReducer(
	initialState,
	on(MessagingActions.message.getArchived, (state) =>
		_.merge(_.cloneDeep(state), { loading: true })
	),
	on(MessagingActions.message.getArchivedSuccess, (state, action) =>
		mergeMessages(state, action)
	),
	on(MessagingActions.message.getArchivedFail, (state, action) =>
		_.merge(_.cloneDeep(state), { error: action.error, loading: false })
	)
);

function updateMessageReadState(state, action): MessageState {
	const conversationMessages = _.get(state, ["messages", action.conversationId]) || [];
	const newState = _.cloneDeep(state);

	const updatedMessages =
		action.type === MessagingActions.conversation.read.type
			? conversationMessages.map((msg) => ({ ...msg, read: msg.sentByMe ? msg.read : true }))
			: action.type === MessagingActions.conversation.readFail.type
				? conversationMessages.map((msg) => ({
						...msg,
						read: msg.sentByMe ? msg.read : false
					}))
				: conversationMessages;

	if (updatedMessages) {
		_.set(newState, ["messages", action.conversationId], updatedMessages);
	}

	return newState;
}

function insertMessage(state, message): MessageState {
	const conversationId = message.conversationId;
	const conversationMessages = _.get(state, ["messages", conversationId]) || [];
	if (conversationMessages.some((msg) => msg.id === message.id)) {
		return state;
	}
	const newState = _.cloneDeep(state);
	_.set(newState, ["messages", conversationId], [...conversationMessages, message]);
	return newState;
}

function mergeMessages(state, action): MessageState {
	let messages = action.messages;
	if (action.type === MessagingActions.conversation.read) {
		messages = action.messages.map((msg) => ({ ...msg, read: true }));
	} else if (action.type === MessagingActions.conversation.readFail) {
		messages = action.messages.map((msg) => ({ ...msg, read: false }));
	}
	const groupedMessages = _.groupBy(messages, "conversationId");
	const newState = _.merge(_.cloneDeep(state), { loading: false });
	_.forEach(_.keys(groupedMessages), (conversationId) => {
		_.set(newState, ["messages", conversationId], groupedMessages[conversationId]);
	});
	return newState;
}

export function messageReducer(state: MessageState | undefined, action: Action): MessageState {
	return reducer(state, action);
}

export function archivedMessageReducer(
	state: MessageState | undefined,
	action: Action
): MessageState {
	return archiveReducer(state, action);
}
